(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-antes-y-despues"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var marco = raiz.querySelector('[data-ad-marco]');
    var capa = raiz.querySelector('[data-ad-despues]');
    var divisor = raiz.querySelector('[data-ad-divisor]');
    var tirador = raiz.querySelector('[data-ad-tirador]');
    if (!marco || !capa || !divisor) return;

    var pos = parseFloat(raiz.getAttribute('data-inicio'));
    if (isNaN(pos)) pos = 50;
    var arrastrando = false;

    function pintar(p) {
      p = Math.max(0, Math.min(100, p));
      pos = p;
      capa.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      divisor.style.left = p + '%';
      if (tirador) tirador.setAttribute('aria-valuenow', Math.round(p));
    }

    function desdeX(x) {
      var r = marco.getBoundingClientRect();
      if (r.width === 0) return pos;
      return ((x - r.left) / r.width) * 100;
    }

    function onDown(e) {
      arrastrando = true;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      pintar(desdeX(x));
    }

    function onMove(e) {
      if (!arrastrando) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      pintar(desdeX(x));
    }

    function onUp() {
      arrastrando = false;
    }

    marco.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    marco.addEventListener('touchstart', onDown, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);

    if (tirador) {
      tirador.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          pintar(pos - 4);
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          pintar(pos + 4);
          e.preventDefault();
        } else if (e.key === 'Home') {
          pintar(0);
          e.preventDefault();
        } else if (e.key === 'End') {
          pintar(100);
          e.preventDefault();
        }
      });
      tirador.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }

    pintar(pos);
  }

  function iniciarTodo() {
    var nodos = document.querySelectorAll('[data-ps-ad]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  if (document.readyState !== 'loading') {
    iniciarTodo();
  } else {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-anuncios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarBarra(raiz) {
    var pista = raiz.querySelector('.ps-anuncios__pista');
    if (!pista) return;
    var items = pista.querySelectorAll('.ps-anuncios__item');
    if (items.length === 0) return;

    var autoplay = raiz.getAttribute('data-autoplay') === 'true';
    var velocidad = parseInt(raiz.getAttribute('data-velocidad'), 10) || 4000;
    var pausarHover = raiz.getAttribute('data-pausar-hover') === 'true';
    var indice = 0;
    var temporizador = null;

    function ajustarAltura() {
      var alto = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetHeight > alto) alto = items[i].offsetHeight;
      }
      if (alto > 0) pista.style.height = alto + 'px';
    }

    function mostrar(n) {
      for (var i = 0; i < items.length; i++) {
        var activo = i === n;
        items[i].classList.toggle('ps-anuncios__item--activo', activo);
        items[i].setAttribute('aria-hidden', activo ? 'false' : 'true');
      }
    }

    function siguiente() {
      indice = (indice + 1) % items.length;
      mostrar(indice);
    }

    function iniciar() {
      if (!autoplay || items.length < 2) return;
      detener();
      temporizador = setInterval(siguiente, velocidad);
    }

    function detener() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    ajustarAltura();
    mostrar(0);
    iniciar();

    window.addEventListener('resize', ajustarAltura);
    window.addEventListener('load', ajustarAltura);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(ajustarAltura);
    }
    if (pausarHover) {
      raiz.addEventListener('mouseenter', detener);
      raiz.addEventListener('mouseleave', iniciar);
    }
  }

  function iniciarTodo() {
    var barras = document.querySelectorAll('[data-ps-anuncios]');
    for (var i = 0; i < barras.length; i++) iniciarBarra(barras[i]);
  }

  if (document.readyState !== 'loading') {
    iniciarTodo();
  } else {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-barra-de-iconos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var contexto = raiz && raiz.querySelectorAll ? raiz : document;
    var secciones = contexto.querySelectorAll('.ps-gar');
    Array.prototype.forEach.call(secciones, function (sec) {
      if (sec.getAttribute('data-ps-gar-listo') === '1') return;
      var visor = sec.querySelector('[data-ps-gar-visor]');
      var pista = sec.querySelector('[data-ps-gar-pista]');
      if (!visor || !pista || pista.className.indexOf('ps-gar__grid--carrusel') === -1) return;
      sec.setAttribute('data-ps-gar-listo', '1');
      var puntos = sec.querySelectorAll('[data-ps-gar-punto]');
      var items = Array.prototype.slice.call(pista.querySelectorAll('.ps-gar__item'));
      var indice = 0;
      var paso = 0;
      var x0 = 0;
      var y0 = 0;
      var dx = 0;
      var eje = null;
      var activo = false;
      var temporizador = null;
      function movil() {
        return window.getComputedStyle(visor).overflowX === 'hidden';
      }
      function medir() {
        var hueco = parseFloat(window.getComputedStyle(pista).columnGap);
        if (isNaN(hueco)) hueco = 0;
        paso = visor.clientWidth + hueco;
      }
      function colocar() {
        if (!movil()) { pista.style.transform = ''; return; }
        pista.style.transform = 'translate3d(' + (dx - indice * paso) + 'px, 0, 0)';
      }
      function pintar() {
        Array.prototype.forEach.call(puntos, function (p, n) {
          var encendido = n === indice;
          if (encendido) { p.classList.add('ps-gar__punto--activo'); } else { p.classList.remove('ps-gar__punto--activo'); }
          p.setAttribute('aria-current', encendido ? 'true' : 'false');
        });
      }
      function irA(i) {
        indice = Math.max(0, Math.min(items.length - 1, i));
        pista.classList.remove('ps-gar__grid--fijo');
        colocar();
        pintar();
      }
      function refrescar() {
        pista.classList.add('ps-gar__grid--fijo');
        medir();
        colocar();
        window.setTimeout(function () { pista.classList.remove('ps-gar__grid--fijo'); }, 60);
      }
      function comenzar(e) {
        if (!movil() || items.length < 2) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        medir();
        x0 = e.clientX;
        y0 = e.clientY;
        dx = 0;
        eje = null;
        activo = true;
        pista.classList.add('ps-gar__grid--fijo');
      }
      function mover(e) {
        if (!activo) return;
        var mx = e.clientX - x0;
        var my = e.clientY - y0;
        if (eje === null) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          eje = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (eje === 'y') { terminar(); return; }
        }
        if ((indice === 0 && mx > 0) || (indice === items.length - 1 && mx < 0)) { dx = mx * 0.3; } else { dx = mx; }
        colocar();
      }
      function terminar() {
        if (!activo) return;
        activo = false;
        var recorrido = dx;
        dx = 0;
        pista.classList.remove('ps-gar__grid--fijo');
        var umbral = Math.max(40, paso * 0.18);
        if (recorrido < -umbral) { irA(indice + 1); } else if (recorrido > umbral) { irA(indice - 1); } else { colocar(); }
      }
      pista.addEventListener('pointerdown', comenzar);
      window.addEventListener('pointermove', mover, { passive: true });
      window.addEventListener('pointerup', terminar);
      window.addEventListener('pointercancel', terminar);
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(refrescar, 120);
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (!pista.contains(e.target)) return;
        var i = items.indexOf(e.target);
        if (i > -1) irA(i);
      });
      refrescar();
      pintar();
      Array.prototype.forEach.call(puntos, function (p, i) {
        p.addEventListener('click', function () { medir(); irA(i); });
      });
      if (window.ResizeObserver) {
        var observador = new window.ResizeObserver(function () { refrescar(); });
        observador.observe(visor);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var sel = raiz.querySelector('[data-col-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var filtros = raiz.querySelector('[data-col-filtros]');
    if (filtros) {
      var casillas = filtros.querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < casillas.length; i++) {
        casillas[i].addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.search = '';
          var datos = new FormData(filtros);
          var entradas = datos.entries();
          var e = entradas.next();
          while (!e.done) {
            if (e.value[1]) url.searchParams.append(e.value[0], e.value[1]);
            e = entradas.next();
          }
          var orden = raiz.querySelector('[data-col-select]');
          if (orden && orden.value) url.searchParams.set('sort_by', orden.value);
          window.location.href = url.toString();
        });
      }
      document.addEventListener('click', function (ev) {
        var abiertos = filtros.querySelectorAll('details[open]');
        for (var k = 0; k < abiertos.length; k++) {
          if (!abiertos[k].contains(ev.target)) abiertos[k].removeAttribute('open');
        }
      });
    }
  }

  function iniciarTodo() {
    var nodos = document.querySelectorAll('[data-ps-col]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  if (document.readyState !== 'loading') {
    iniciarTodo();
  } else {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-faqs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var unaALaVez = raiz.getAttribute('data-una-a-la-vez') === 'true';
    var items = raiz.querySelectorAll('[data-faq-item]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function duracion() {
      var v = getComputedStyle(raiz).getPropertyValue('--f-dur');
      var n = parseFloat(v);
      return isNaN(n) ? 320 : n;
    }

    function cerrarConAnimacion(otro) {
      var p = otro.querySelector('[data-faq-panel]');
      var r = otro.querySelector('.ps-faq__respuesta');
      if (!p || reduce) {
        otro.open = false;
        return;
      }
      p.style.gridTemplateRows = '0fr';
      if (r) {
        r.style.opacity = '0';
        r.style.transform = 'translateY(-6px)';
      }
      window.setTimeout(function () {
        otro.open = false;
        p.style.gridTemplateRows = '';
        if (r) {
          r.style.opacity = '';
          r.style.transform = '';
        }
      }, duracion());
    }

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var resumen = item.querySelector('[data-faq-resumen]');
        var panel = item.querySelector('[data-faq-panel]');
        if (!resumen || !panel) return;
        var animando = false;

        resumen.addEventListener('click', function (e) {
          e.preventDefault();
          if (animando) return;

          if (!item.open) {
            if (unaALaVez) {
              for (var k = 0; k < items.length; k++) {
                if (items[k] !== item && items[k].open) cerrarConAnimacion(items[k]);
              }
            }
            item.open = true;
            if (!reduce) {
              animando = true;
              window.setTimeout(function () {
                animando = false;
              }, duracion());
            }
          } else {
            if (reduce) {
              item.open = false;
              return;
            }
            animando = true;
            cerrarConAnimacion(item);
            window.setTimeout(function () {
              animando = false;
            }, duracion());
          }
        });
      })(items[i]);
    }
  }

  function iniciarTodo() {
    var nodos = document.querySelectorAll('[data-ps-faq]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  if (document.readyState !== 'loading') {
    iniciarTodo();
  } else {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-marquee-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var contexto = raiz && raiz.querySelectorAll ? raiz : document;
    var secciones = contexto.querySelectorAll('[data-ps-mq]');
    Array.prototype.forEach.call(secciones, function (sec) {
      if (sec.getAttribute('data-ps-mq-listo') === '1') return;
      var cinta = sec.querySelector('[data-ps-mq-cinta]');
      var pista = sec.querySelector('[data-ps-mq-pista]');
      if (!cinta || !pista) return;
      var grupos = pista.querySelectorAll('[data-ps-mq-grupo]');
      if (grupos.length < 2) return;
      var base = Array.prototype.slice.call(grupos[0].children);
      if (!base.length) return;
      sec.setAttribute('data-ps-mq-listo', '1');
      var velocidad = parseFloat(sec.getAttribute('data-velocidad'));
      if (isNaN(velocidad) || velocidad < 5) velocidad = 60;
      var temporizador = null;
      function rellenar() {
        var vueltas = 0;
        while (grupos[0].scrollWidth < cinta.clientWidth && vueltas < 12) {
          Array.prototype.forEach.call(grupos, function (g) {
            base.forEach(function (it) {
              var copia = it.cloneNode(true);
              copia.removeAttribute('id');
              g.appendChild(copia);
            });
          });
          vueltas++;
        }
      }
      function ajustar() {
        rellenar();
        var mitad = grupos[0].getBoundingClientRect().width;
        if (mitad < 1) return;
        pista.style.setProperty('--m-dur', (mitad / velocidad).toFixed(2) + 's');
      }
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(ajustar, 150);
      });
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(ajustar);
      }
      ajustar();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product-info-kits"] && !Shopify.designMode) return;
  try {
    
(function () {
  function dur(raiz) {
    var val = getComputedStyle(raiz).getPropertyValue('--p-acc-dur');
    var n = parseFloat(val);
    return isNaN(n) ? 320 : n;
  }
  function mostrarPanel(raiz, tipo, bid, color) {
    var ns = raiz.querySelectorAll('[data-ps-panel="' + tipo + '"]');
    for (var i = 0; i < ns.length; i++) {
      var n = ns[i];
      var ok = n.getAttribute('data-oferta') === bid;
      if (ok && color && n.hasAttribute('data-color')) {
        ok = n.getAttribute('data-color') === color;
      }
      if (ok) { n.removeAttribute('hidden'); } else { n.setAttribute('hidden', ''); }
    }
  }
  function formatoDinero(raiz, centavos) {
    var cod = raiz.getAttribute('data-moneda') || 'MXN';
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: cod, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(centavos / 100);
    } catch (err) {
      return '$' + Math.round(centavos / 100);
    }
  }
  function actualizarEnvio(raiz, precio) {
    var caja = raiz.querySelector('[data-ps-envio]');
    if (!caja) return;
    var umbral = parseInt(caja.getAttribute('data-umbral'), 10);
    if (isNaN(umbral) || umbral <= 0) return;
    var barra = caja.querySelector('[data-ps-envio-barra]');
    var texto = caja.querySelector('[data-ps-envio-texto]');
    var extra = caja.querySelector('[data-ps-envio-extra]');
    var pct = Math.min(100, Math.round((precio / umbral) * 100));
    if (barra) barra.style.width = pct + '%';
    var listo = precio >= umbral;
    if (texto) {
      if (listo) {
        texto.textContent = caja.getAttribute('data-texto-ok') || '';
      } else {
        var base = caja.getAttribute('data-texto-falta') || '';
        texto.textContent = base.replace('{monto}', formatoDinero(raiz, umbral - precio));
      }
    }
    if (extra) {
      if (listo) { extra.setAttribute('hidden', ''); } else { extra.removeAttribute('hidden'); }
    }
  }
  function aplicarSwatch(raiz, btn) {
    if (!btn) return;
    var bid = btn.getAttribute('data-oferta');
    var color = btn.getAttribute('data-color');
    var grupo = btn.parentNode;
    if (grupo) {
      var hermanos = grupo.querySelectorAll('[data-ps-swatch]');
      for (var i = 0; i < hermanos.length; i++) hermanos[i].classList.remove('ps-pdp__swatch--activo');
      var caja = grupo.parentNode;
      var etq = caja ? caja.querySelector('[data-ps-color-valor]') : null;
      if (etq) etq.textContent = color;
    }
    btn.classList.add('ps-pdp__swatch--activo');
    var input = raiz.querySelector('.product-variant-id');
    if (input) input.value = btn.getAttribute('data-variante');
    var pNodo = raiz.querySelector('[data-ps-precio]');
    if (pNodo) pNodo.textContent = btn.getAttribute('data-precio-txt') || '';
    var oNodo = raiz.querySelector('[data-ps-precio-old]');
    var cmp = btn.getAttribute('data-compare-txt') || '';
    if (oNodo) {
      oNodo.textContent = cmp;
      if (cmp) { oNodo.removeAttribute('hidden'); } else { oNodo.setAttribute('hidden', ''); }
    }
    var aNodo = raiz.querySelector('[data-ps-ahorro]');
    var ah = btn.getAttribute('data-ahorro-txt') || '';
    if (aNodo) {
      aNodo.textContent = ah;
      if (ah) { aNodo.removeAttribute('hidden'); } else { aNodo.setAttribute('hidden', ''); }
    }
    var cta = raiz.querySelector('[data-ps-cta]');
    var ctaTxt = raiz.querySelector('[data-ps-cta-texto]');
    var disp = btn.getAttribute('data-disponible') === 'true';
    if (cta) {
      cta.disabled = !disp;
      if (ctaTxt) {
        var lab = disp ? cta.getAttribute('data-txt-ok') : cta.getAttribute('data-txt-no');
        if (lab) ctaTxt.textContent = lab;
      }
    }
    var precio = parseInt(btn.getAttribute('data-precio'), 10);
    if (!isNaN(precio)) actualizarEnvio(raiz, precio);
    mostrarPanel(raiz, 'galeria', bid, color);
  }
  function seleccionarOferta(raiz, bid, colorPreferido) {
    var cards = raiz.querySelectorAll('[data-ps-oferta]');
    for (var i = 0; i < cards.length; i++) {
      var esta = cards[i].getAttribute('data-oferta') === bid;
      if (esta) { cards[i].classList.add('ps-pdp__oferta--activa'); } else { cards[i].classList.remove('ps-pdp__oferta--activa'); }
      cards[i].setAttribute('aria-pressed', esta ? 'true' : 'false');
    }
    mostrarPanel(raiz, 'cabecera', bid, null);
    mostrarPanel(raiz, 'nota', bid, null);
    mostrarPanel(raiz, 'incluye', bid, null);
    mostrarPanel(raiz, 'resenas', bid, null);
    mostrarPanel(raiz, 'colores', bid, null);
    var todos = raiz.querySelectorAll('[data-ps-swatch]');
    var propios = [];
    for (var k = 0; k < todos.length; k++) {
      if (todos[k].getAttribute('data-oferta') === bid) propios.push(todos[k]);
    }
    if (!propios.length) return;
    var elegido = null;
    if (colorPreferido) {
      for (var m = 0; m < propios.length; m++) {
        if (propios[m].getAttribute('data-color') === colorPreferido) { elegido = propios[m]; break; }
      }
    }
    if (!elegido) {
      for (var n = 0; n < propios.length; n++) {
        if (propios[n].getAttribute('data-disponible') === 'true') { elegido = propios[n]; break; }
      }
    }
    if (!elegido) elegido = propios[0];
    aplicarSwatch(raiz, elegido);
  }
  function cambiarMini(btn) {
    var gal = btn.closest('.ps-pdp__galeria');
    if (!gal) return;
    var img = gal.querySelector('.ps-pdp__img');
    if (img) {
      var src = btn.getAttribute('data-src');
      if (src) {
        img.src = src;
        img.removeAttribute('srcset');
        img.alt = btn.getAttribute('data-alt') || '';
      }
    }
    var hs = gal.querySelectorAll('[data-ps-mini]');
    for (var i = 0; i < hs.length; i++) hs[i].classList.remove('ps-pdp__mini--activa');
    btn.classList.add('ps-pdp__mini--activa');
  }
  function cerrarAcc(raiz, item) {
    var p = item.querySelector('[data-acc-panel]');
    var c = item.querySelector('.ps-pdp__acc-contenido');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!p || reduce) { item.open = false; return; }
    p.style.gridTemplateRows = '0fr';
    if (c) { c.style.opacity = '0'; c.style.transform = 'translateY(-6px)'; }
    window.setTimeout(function () {
      item.open = false;
      p.style.gridTemplateRows = '';
      if (c) { c.style.opacity = ''; c.style.transform = ''; }
    }, dur(raiz));
  }
  function alternarAcc(raiz, res, ev) {
    var item = res.parentNode;
    var cont = raiz.querySelector('[data-ps-acordeones]');
    if (!item || !cont) return;
    ev.preventDefault();
    if (item.getAttribute('data-anim') === '1') return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = cont.querySelectorAll('[data-acc-item]');
    var una = cont.getAttribute('data-una-a-la-vez') === 'true';
    if (!item.open) {
      if (una) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] !== item && items[i].open) cerrarAcc(raiz, items[i]);
        }
      }
      item.open = true;
    } else {
      if (reduce) { item.open = false; return; }
      cerrarAcc(raiz, item);
    }
    if (!reduce) {
      item.setAttribute('data-anim', '1');
      window.setTimeout(function () { item.removeAttribute('data-anim'); }, dur(raiz));
    }
  }
  function iniciarSeleccion(raiz) {
    var activa = raiz.querySelector('[data-ps-oferta].ps-pdp__oferta--activa');
    var sw = raiz.querySelector('[data-ps-swatch].ps-pdp__swatch--activo');
    if (activa) {
      seleccionarOferta(raiz, activa.getAttribute('data-oferta'), sw ? sw.getAttribute('data-color') : null);
      return;
    }
    if (sw) { aplicarSwatch(raiz, sw); return; }
    var base = parseInt(raiz.getAttribute('data-precio-inicial'), 10);
    if (!isNaN(base)) actualizarEnvio(raiz, base);
  }
  function preparar(raiz) {
    if (raiz.getAttribute('data-ps-pdp-listo') === '1') return;
    raiz.setAttribute('data-ps-pdp-listo', '1');
    raiz.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      try {
        var sw = t.closest('[data-ps-swatch]');
        if (sw && raiz.contains(sw)) { aplicarSwatch(raiz, sw); return; }
        var of = t.closest('[data-ps-oferta]');
        if (of && raiz.contains(of)) {
          var act = raiz.querySelector('[data-ps-swatch].ps-pdp__swatch--activo');
          seleccionarOferta(raiz, of.getAttribute('data-oferta'), act ? act.getAttribute('data-color') : null);
          return;
        }
        var mini = t.closest('[data-ps-mini]');
        if (mini && raiz.contains(mini)) { cambiarMini(mini); return; }
        var res = t.closest('[data-acc-resumen]');
        if (res && raiz.contains(res)) { alternarAcc(raiz, res, ev); return; }
      } catch (err) {}
    });
    try { iniciarSeleccion(raiz); } catch (err) {}
  }
  function iniciarTodo(raiz) {
    var contexto = raiz && raiz.querySelectorAll ? raiz : document;
    var nodos = contexto.querySelectorAll('[data-ps-pdp]');
    for (var i = 0; i < nodos.length; i++) preparar(nodos[i]);
  }
  if (document.readyState !== 'loading') {
    iniciarTodo(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodo(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { iniciarTodo(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product-info-pluma"] && !Shopify.designMode) return;
  try {
    
(function () {
  function dur(raiz) {
    var val = getComputedStyle(raiz).getPropertyValue('--pl-acc-dur');
    var n = parseFloat(val);
    return isNaN(n) ? 320 : n;
  }
  function mostrarPanel(raiz, tipo, bid) {
    var ns = raiz.querySelectorAll('[data-ps-panel="' + tipo + '"]');
    for (var i = 0; i < ns.length; i++) {
      if (ns[i].getAttribute('data-oferta') === bid) {
        ns[i].removeAttribute('hidden');
      } else {
        ns[i].setAttribute('hidden', '');
      }
    }
  }
  function seleccionarOferta(raiz, btn) {
    if (!btn) return;
    var bid = btn.getAttribute('data-oferta');
    var cards = raiz.querySelectorAll('[data-ps-oferta]');
    for (var i = 0; i < cards.length; i++) {
      var esta = cards[i] === btn;
      if (esta) { cards[i].classList.add('ps-pluma__oferta--activa'); } else { cards[i].classList.remove('ps-pluma__oferta--activa'); }
      cards[i].setAttribute('aria-pressed', esta ? 'true' : 'false');
    }
    mostrarPanel(raiz, 'nota', bid);
    var cant = raiz.querySelector('[data-ps-cantidad]');
    if (cant) cant.value = btn.getAttribute('data-cantidad') || '1';
    var pNodo = raiz.querySelector('[data-ps-precio]');
    if (pNodo) pNodo.textContent = btn.getAttribute('data-precio-txt') || '';
    var oNodo = raiz.querySelector('[data-ps-precio-old]');
    var cmp = btn.getAttribute('data-compare-txt') || '';
    if (oNodo) {
      oNodo.textContent = cmp;
      if (cmp) { oNodo.removeAttribute('hidden'); } else { oNodo.setAttribute('hidden', ''); }
    }
    var aNodo = raiz.querySelector('[data-ps-ahorro]');
    var ah = btn.getAttribute('data-ahorro-txt') || '';
    if (aNodo) {
      aNodo.textContent = ah;
      if (ah) { aNodo.removeAttribute('hidden'); } else { aNodo.setAttribute('hidden', ''); }
    }
  }
  function cambiarMini(btn) {
    var gal = btn.closest('.ps-pluma__galeria');
    if (!gal) return;
    var img = gal.querySelector('.ps-pluma__img');
    if (img) {
      var src = btn.getAttribute('data-src');
      if (src) {
        img.src = src;
        img.removeAttribute('srcset');
        img.alt = btn.getAttribute('data-alt') || '';
      }
    }
    var hs = gal.querySelectorAll('[data-ps-mini]');
    for (var i = 0; i < hs.length; i++) hs[i].classList.remove('ps-pluma__mini--activa');
    btn.classList.add('ps-pluma__mini--activa');
  }
  function cerrarAcc(raiz, item) {
    var p = item.querySelector('[data-acc-panel]');
    var c = item.querySelector('.ps-pluma__acc-contenido');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!p || reduce) { item.open = false; return; }
    p.style.gridTemplateRows = '0fr';
    if (c) { c.style.opacity = '0'; c.style.transform = 'translateY(-6px)'; }
    window.setTimeout(function () {
      item.open = false;
      p.style.gridTemplateRows = '';
      if (c) { c.style.opacity = ''; c.style.transform = ''; }
    }, dur(raiz));
  }
  function alternarAcc(raiz, res, ev) {
    var item = res.parentNode;
    var cont = raiz.querySelector('[data-ps-acordeones]');
    if (!item || !cont) return;
    ev.preventDefault();
    if (item.getAttribute('data-anim') === '1') return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = cont.querySelectorAll('[data-acc-item]');
    var una = cont.getAttribute('data-una-a-la-vez') === 'true';
    if (!item.open) {
      if (una) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] !== item && items[i].open) cerrarAcc(raiz, items[i]);
        }
      }
      item.open = true;
    } else {
      if (reduce) { item.open = false; return; }
      cerrarAcc(raiz, item);
    }
    if (!reduce) {
      item.setAttribute('data-anim', '1');
      window.setTimeout(function () { item.removeAttribute('data-anim'); }, dur(raiz));
    }
  }
  function preparar(raiz) {
    if (raiz.getAttribute('data-ps-pluma-listo') === '1') return;
    raiz.setAttribute('data-ps-pluma-listo', '1');
    raiz.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      try {
        var of = t.closest('[data-ps-oferta]');
        if (of && raiz.contains(of)) { seleccionarOferta(raiz, of); return; }
        var mini = t.closest('[data-ps-mini]');
        if (mini && raiz.contains(mini)) { cambiarMini(mini); return; }
        var res = t.closest('[data-acc-resumen]');
        if (res && raiz.contains(res)) { alternarAcc(raiz, res, ev); return; }
      } catch (err) {}
    });
    try {
      var act = raiz.querySelector('[data-ps-oferta].ps-pluma__oferta--activa');
      if (act) seleccionarOferta(raiz, act);
    } catch (err) {}
  }
  function iniciarTodo(raiz) {
    var contexto = raiz && raiz.querySelectorAll ? raiz : document;
    var nodos = contexto.querySelectorAll('[data-ps-pluma]');
    for (var i = 0; i < nodos.length; i++) preparar(nodos[i]);
  }
  if (document.readyState !== 'loading') {
    iniciarTodo(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodo(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { iniciarTodo(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-reviews-con-foto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    var contexto = raiz && raiz.querySelectorAll ? raiz : document;
    var secciones = contexto.querySelectorAll('.ps-rev');
    Array.prototype.forEach.call(secciones, function (sec) {
      if (sec.getAttribute('data-ps-rev-listo') === '1') return;
      var visor = sec.querySelector('[data-ps-rev-visor]');
      var pista = sec.querySelector('[data-ps-rev-pista]');
      if (!visor || !pista) return;
      var items = Array.prototype.slice.call(pista.querySelectorAll('.ps-rev__item'));
      if (!items.length) return;
      sec.setAttribute('data-ps-rev-listo', '1');
      var puntos = sec.querySelectorAll('[data-ps-rev-punto]');
      var ant = sec.querySelector('[data-ps-rev-ant]');
      var sig = sec.querySelector('[data-ps-rev-sig]');
      var indice = 0;
      var paso = 0;
      var tope = 0;
      var x0 = 0;
      var y0 = 0;
      var dx = 0;
      var eje = null;
      var activo = false;
      var temporizador = null;
      function medir() {
        var hueco = parseFloat(window.getComputedStyle(pista).columnGap);
        if (isNaN(hueco)) hueco = 0;
        paso = items[0].getBoundingClientRect().width + hueco;
        if (paso < 1) paso = visor.clientWidth;
        var visibles = Math.max(1, Math.round((visor.clientWidth + hueco) / paso));
        tope = Math.max(0, items.length - visibles);
        if (indice > tope) indice = tope;
      }
      function colocar() {
        pista.style.transform = 'translate3d(' + (dx - indice * paso) + 'px, 0, 0)';
      }
      function pintar() {
        Array.prototype.forEach.call(puntos, function (p, n) {
          if (n > tope) { p.classList.add('ps-rev__punto--oculto'); } else { p.classList.remove('ps-rev__punto--oculto'); }
          var encendido = n === indice;
          if (encendido) { p.classList.add('ps-rev__punto--activo'); } else { p.classList.remove('ps-rev__punto--activo'); }
          p.setAttribute('aria-current', encendido ? 'true' : 'false');
        });
        if (ant) {
          ant.disabled = indice <= 0;
          if (tope === 0) { ant.classList.add('ps-rev__flecha--oculta'); } else { ant.classList.remove('ps-rev__flecha--oculta'); }
        }
        if (sig) {
          sig.disabled = indice >= tope;
          if (tope === 0) { sig.classList.add('ps-rev__flecha--oculta'); } else { sig.classList.remove('ps-rev__flecha--oculta'); }
        }
      }
      function irA(i) {
        indice = Math.max(0, Math.min(tope, i));
        pista.classList.remove('ps-rev__pista--fijo');
        colocar();
        pintar();
      }
      function refrescar() {
        pista.classList.add('ps-rev__pista--fijo');
        medir();
        colocar();
        pintar();
        window.setTimeout(function () { pista.classList.remove('ps-rev__pista--fijo'); }, 60);
      }
      function comenzar(e) {
        if (items.length < 2) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        medir();
        if (tope === 0) return;
        x0 = e.clientX;
        y0 = e.clientY;
        dx = 0;
        eje = null;
        activo = true;
        pista.classList.add('ps-rev__pista--fijo');
      }
      function mover(e) {
        if (!activo) return;
        var mx = e.clientX - x0;
        var my = e.clientY - y0;
        if (eje === null) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          eje = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (eje === 'y') { terminar(); return; }
        }
        if ((indice === 0 && mx > 0) || (indice === tope && mx < 0)) { dx = mx * 0.3; } else { dx = mx; }
        colocar();
      }
      function terminar() {
        if (!activo) return;
        activo = false;
        var recorrido = dx;
        dx = 0;
        pista.classList.remove('ps-rev__pista--fijo');
        var umbral = Math.max(40, paso * 0.18);
        if (recorrido < -umbral) { irA(indice + 1); } else if (recorrido > umbral) { irA(indice - 1); } else { colocar(); }
      }
      pista.addEventListener('pointerdown', comenzar);
      window.addEventListener('pointermove', mover, { passive: true });
      window.addEventListener('pointerup', terminar);
      window.addEventListener('pointercancel', terminar);
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(refrescar, 120);
      });
      if (ant) ant.addEventListener('click', function () { medir(); irA(indice - 1); });
      if (sig) sig.addEventListener('click', function () { medir(); irA(indice + 1); });
      Array.prototype.forEach.call(puntos, function (p, i) {
        p.addEventListener('click', function () { medir(); irA(i); });
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (!pista.contains(e.target)) return;
        var i = items.indexOf(e.target);
        medir();
        if (i > -1) irA(i);
      });
      refrescar();
      if (window.ResizeObserver) {
        var observador = new window.ResizeObserver(function () { refrescar(); });
        observador.observe(visor);
      }
      Array.prototype.forEach.call(pista.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', refrescar, { once: true });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
